
import { apiAiRecordLists } from "@/api/setting";
import { Component, Prop, Vue } from "vue-property-decorator";
import LsPagination from "@/components/ls-pagination.vue";
import { RequestPaging } from "@/utils/util";
import LsDialog from "@/components/ls-dialog.vue";
import PromotCommon from "@/components/promot-common.vue";

@Component({
  components: {
    LsDialog,
    LsPagination,
    PromotCommon,
  },
})
export default class AiUserLog extends Vue {
  // 分页
  pager: RequestPaging = new RequestPaging();
  apiAiRecordLists = apiAiRecordLists;
  searchObj: any = {
    title: "",
    status: "",
  };

  // 获取列表
  getList() {
    this.pager
      .request({
        callback: apiAiRecordLists,
        params: this.searchObj,
      })
      .then((res) => {
        res.lists.forEach((item: any) => {
          item.other_info = JSON.parse(item.other_info || "{}");
        });
        console.log(res);
      });
  }

  created() {
    this.getList();
  }
}
